msgid ""
msgstr ""
"POT-Creation-Date: 2021-01-20 11:28+0100\n"
"Mime-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: de\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

msgid "“{loginLabel}” was deleted."
msgstr "„{loginLabel}“ wurde gelöscht."

#. placeholder {0}: getMoveTargetLabel(movedLoginInfo)
msgid "“{loginLabel}” was moved to “{0}”."
msgstr "„{loginLabel}“ wurde nach „{0}“ verschoben."

msgid "“{loginLabel}” was moved to the <0>recycle bin</0>."
msgstr "„{loginLabel}“ wurde in den <0>Papierkorb</0> verschoben."

#. placeholder {0}: movedLoginInfo.recipientEmail
msgid "“{loginLabel}” was transferred to the personal logins of “{0}”."
msgstr "„{loginLabel}“ wurde in die persönlichen Logins von „{0}“ übertragen."

msgid "(changed)"
msgstr "(geändert)"

#. placeholder {0}: validUntilWarning.days
msgid "{0, plural, =0 {Expired today} one {Expired yesterday} other {Expired # days ago}}"
msgstr "{0, plural, =0 {Heute abgelaufen} one {Gestern abgelaufen} other {Vor # Tagen abgelaufen}}"

#. placeholder {0}: validUntilWarning.days
msgid "{0, plural, =0 {Expires today} one {Expires tomorrow} other {Expires in # days}}"
msgstr "{0, plural, =0 {Läuft heute ab} one {Läuft morgen ab} other {Läuft in # Tagen ab}}"

#. placeholder {0}: validFromWarning.days
msgid "{0, plural, =0 {Valid from later today} one {Valid from tomorrow} other {Valid in # days}}"
msgstr "{0, plural, =0 {Gültig ab heute im Laufe des Tages} one {Gültig ab morgen} other {Gültig in # Tagen}}"

msgid "{fieldName} (old)"
msgstr "{fieldName} (alt)"

msgid "#@$"
msgstr "#@$"

#. placeholder {0}: format(new Date(login.importInfo.importTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "<0>Imported</0> on {0}"
msgstr "<0>Importiert</0> am {0}"

msgid "0{nonBreakingHyphen}9"
msgstr "0{nonBreakingHyphen}9"

msgid "a{nonBreakingHyphen}z"
msgstr "a{nonBreakingHyphen}z"

msgid "A{nonBreakingHyphen}Z"
msgstr "A{nonBreakingHyphen}Z"

msgid "Active"
msgstr "Aktiv"

msgid "Add"
msgstr "Hinzufügen"

msgid "Add Android app"
msgstr "Android-App hinzufügen"

msgid "Add display name"
msgstr "Anzeigename hinzufügen"

msgid "Add more"
msgstr "Weitere hinzufügen"

msgid "Add new field"
msgstr "Neues Feld hinzufügen"

msgid "Add password"
msgstr "Passwort hinzufügen"

msgid "Add title"
msgstr "Titel hinzufügen"

msgid "Add to heylogin"
msgstr "Zu heylogin hinzufügen"

msgid "Add TOTP secret"
msgstr "TOTP-Schlüssel hinzufügen"

msgid "Add website"
msgstr "Webseite hinzufügen"

msgid "Add Windows app"
msgstr "Windows-App hinzufügen"

msgid "All fields are end-to-end encrypted."
msgstr "Alle Felder sind Ende-zu-Ende-verschlüsselt."

msgid "Alt"
msgstr "Alt"

msgid "An error happened because the page was modified by an extension or translation tool. Please disable translation or extensions and try again."
msgstr "Es ist ein Fehler aufgetreten, weil die Seite durch einen Übersetzer oder eine Browser-Erweiterung verändert wurde. Bitte deaktiviere Übersetzung und Erweiterungen und versuche es nochmal."

msgid "Android app"
msgstr "Android-App"

msgid "Android apps"
msgstr "Android-Apps"

msgid "App"
msgstr "App"

msgid "Apply"
msgstr "Übernehmen"

msgid "Autofill"
msgstr "Automatisches Ausfüllen"

msgid "Autofill enabled"
msgstr "Automatisches Ausfüllen aktiviert"

msgid "Browse"
msgstr "Durchsuchen"

msgid "by {creationProfileEmail}"
msgstr "von {creationProfileEmail}"

msgid "by {editProfileEmail}"
msgstr "von {editProfileEmail}"

msgid "Cancel"
msgstr "Abbrechen"

msgid "Card holder"
msgstr "Karteninhaber"

msgid "Card number"
msgstr "Kreditkartennummer"

msgid "Certificate accepted"
msgstr "Zertifikat wurde erkannt"

msgid "Change"
msgstr "Ändern"

msgid "Change settings"
msgstr "Einstellungen ändern"

msgid "Checking file…"
msgstr "Datei wird überprüft…"

msgid "Checking system clock…"
msgstr "Uhrzeit wird überprüft…"

msgid "Checking…"
msgstr "Wird überprüft…"

msgid "Clear"
msgstr "Leeren"

msgid "Close"
msgstr "Schließen"

msgid "Compliant"
msgstr "Konform"

msgid "Confirm access"
msgstr "Zugriff erlauben"

msgid "Confirm with one of your login devices"
msgstr "Bestätige mit einem deiner Login-Geräte"

msgid "Confirm with your phone"
msgstr "Bestätige mit deinem Handy"

msgid "Confirm with your security key"
msgstr "Bestätige mit deinem Sicherheitsschlüssel"

msgid "Copied"
msgstr "Kopiert"

msgid "Copy"
msgstr "Kopieren"

#. placeholder {0}: format(new Date(login.creationTime), 'PPPp', { locale: getDateFnsLocale(), })
#. placeholder {0}: format(new Date(login.creationTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "Created on {0}"
msgstr "Erstellt am {0}"

msgid "Creation Date"
msgstr "Erstellungsdatum"

msgid "Credit card"
msgstr "Kreditkarte"

msgid "Credit card information"
msgstr "Kreditkarten-Informationen"

msgid "Ctrl"
msgstr "Strg"

msgid "Custom settings"
msgstr "Benutzerdefiniert"

msgid "Default settings"
msgstr "Standardeinstellungen"

msgid "Del"
msgstr "Entf"

msgid "Delegated Admins"
msgstr "Delegierte Admins"

msgid "Delete"
msgstr "Löschen"

msgid "Disable multiline"
msgstr "Mehrzeilig ausschalten"

msgid "Display name"
msgstr "Anzeigename"

msgid "Does not match recommendation"
msgstr "Entspricht der Empfehlung nicht"

msgid "Done"
msgstr "Fertig"

msgid "Download"
msgstr "Herunterladen"

msgid "Drag and drop or"
msgstr "Drag and Drop oder"

msgid "Drop new certificate file here"
msgstr "Neue Zertifikats-Datei hier ablegen"

msgid "Duplicate login"
msgstr "Login duplizieren"

msgid "Duplicating…"
msgstr "Wird dupliziert…"

msgid "E-mail or username"
msgstr "E-Mail oder Nutzername"

msgid "ELSTER account number"
msgstr "ELSTER-Kontonummer"

msgid "ELSTER Certificate"
msgstr "ELSTER-Zertifikat"

msgid "ELSTER certificate information"
msgstr "ELSTER-Zertifikat-Informationen"

msgid "Email address"
msgstr "E-Mail-Adresse"

msgid "Enable multiline"
msgstr "Mehrzeilig einschalten"

msgid "End"
msgstr "Ende"

msgid "Enter"
msgstr "Enter"

msgid "Error checking password"
msgstr "Fehler beim Überprüfen des Passworts"

msgid "Error checking TOTP availability"
msgstr "Fehler beim Überprüfen der TOTP-Verfügbarkeit"

msgid "Esc"
msgstr "Esc"

msgid "Expiration date"
msgstr "Ablaufdatum"

msgid "Expiration date (mm / yy)"
msgstr "Ablaufdatum (mm / yy)"

msgid "Failed"
msgstr "Fehlgeschlagen"

msgid "Field name"
msgstr "Feld-Name"

msgid "Field settings"
msgstr "Feld-Einstellungen"

#. placeholder {0}: formatBytes(maxSize)
msgid "File is too large, maximum size allowed is {0}"
msgstr "Die Datei ist zu groß, sie darf höchstens {0} groß sein"

#. placeholder {0}: formatBytes(minSize)
msgid "File is too small, minimum size required is {0}"
msgstr "Die Datei ist zu klein, sie muss mindestens {0} groß sein"

#. placeholder {0}: unpackedAccept[0]
msgid "File type must be {0}"
msgstr "Die Datei muss den Typ {0} haben"

msgid "File type must be one of {commaSeparatedAccept}"
msgstr "Die Datei muss einen der folgenden Typen haben: {commaSeparatedAccept}"

msgid "Generate password"
msgstr "Passwort generieren"

msgid "Generate PIN"
msgstr "PIN generieren"

msgid "Generated by heylogin"
msgstr "Von heylogin generiert"

msgid "Generated by: "
msgstr "Generiert nach: "

msgid "Go to duplicated login"
msgstr "Zum duplizierten Login gehen"

msgid "Go to login"
msgstr "Zum Login gehen"

msgid "Got it"
msgstr "Okay"

msgid "heylogin is the first password manager with full hardware-based end-to-end encryption. 2-factor secure by default, developed and hosted in Germany."
msgstr "heylogin ist der erste Passwort-Manager mit hardwarebasierter Ende-zu-Ende-Verschlüsselung. Standardmäßig 2-Faktor-sicher, entwickelt und gehostet in Deutschland."

msgid "heylogin screenshot"
msgstr "Screenshot von heylogin"

msgid "heylogin was updated"
msgstr "heylogin wurde aktualisiert"

msgid "Hide"
msgstr "Verbergen"

msgid "Hide content"
msgstr "Inhalt verstecken"

msgid "Home"
msgstr "Pos1"

#. help center link: additional login fields
msgid "https://help.heylogin.com/en/0113ca3fb5284ef08f4abbdb2571b0a3"
msgstr "https://help.heylogin.com/de/fe995ff0b62940649072fcb58bbab3d5"

#. help center link: login status
msgid "https://help.heylogin.com/en/1938872c7eda802da7b7da7cb484138c"
msgstr "https://help.heylogin.com/de/1938872c7eda805baaeeefe4886d1ea5"

#. help center link: passkey
msgid "https://help.heylogin.com/en/2bc8872c7eda8049b518db4bb0d10b2c"
msgstr "https://help.heylogin.com/de/2bc8872c7eda8049b518db4bb0d10b2c"

#. help center link: elster certificate
msgid "https://help.heylogin.com/en/37a8872c7eda80309906df0837fe7220"
msgstr "https://help.heylogin.com/de/37a8872c7eda8032ba83dd867742db02"

#. help center link: login troubleshooting
msgid "https://help.heylogin.com/en/4200f43b493c4bb18c8e16bffcd40071"
msgstr "https://help.heylogin.com/de/2be545c602c144d6992a50e6301afa18"

msgid "https://help.heylogin.com/en/96e629e684bf4d3a89d0d8c47aa78395"
msgstr "https://help.heylogin.com/de/c6e5f4fef9bf4660a977219e8e664f20"

#. help center link: security keys / faq / firefox on windows error
msgid "https://help.heylogin.com/en/e7d73dc2d84c4306ad83129ae969b4d7#29c8872c7eda80ceb294e0ff292f7b51"
msgstr "https://help.heylogin.com/de/ce898ec247c542d0bc62af6d20f20bd1#29c8872c7eda8037ab48f8d186a7e94c"

msgid "https://www.heylogin.com/en/site-notice"
msgstr "https://www.heylogin.com/de/impressum"

msgid "https://www.heylogin.com/en/terms-of-use"
msgstr "https://www.heylogin.com/de/nutzungsbedingungen"

msgid "Import"
msgstr "Import"

#. placeholder {0}: format(new Date(login.importInfo.importTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "Imported on {0}"
msgstr "Importiert am {0}"

msgid "Incorrect password for this certificate"
msgstr "Falsches Passwort für dieses Zertifikat"

msgid "Input by user"
msgstr "Nutzer-Eingabe"

msgid "Ins"
msgstr "Einfg"

msgid "Invalid"
msgstr "Nicht valide"

msgid "Invalid card number"
msgstr "Ungültige Kreditkartennummer"

msgid "Invalid expiration date"
msgstr "Ungültiges Ablaufdatum"

msgid "Invalid security code"
msgstr "Ungültiger Sicherheitscode"

msgid "Label already added"
msgstr "Label bereits hinzugefügt"

msgid "Label name"
msgstr "Labelname"

msgid "Labels"
msgstr "Labels"

msgid "Labels:"
msgstr "Labels:"

#. placeholder {0}: format(new Date(login.editTime), 'PPPp', { locale: getDateFnsLocale(), })
msgid "Last edited on {0}"
msgstr "Zuletzt bearbeitet am {0}"

msgid "Leak check:"
msgstr "Leak-Check:"

msgid "Leaked"
msgstr "Geleakt"

msgid "Learn more"
msgstr "Mehr erfahren"

msgid "Learn more about heylogin"
msgstr "Mehr über heylogin erfahren"

msgid "Length"
msgstr "Länge"

msgid "Logging in"
msgstr "Du wirst eingeloggt"

msgid "Login"
msgstr "Login"

msgid "Login cancelled"
msgstr "Login abgebrochen"

msgid "Login Inbox"
msgstr "Login-Posteingang"

msgid "Login information"
msgstr "Login-Informationen"

msgid "Login status"
msgstr "Login-Status"

msgid "Manual input"
msgstr "Manuelle Eingabe"

msgid "Matches recommendation"
msgstr "Entspricht der Empfehlung"

#. placeholder {0}: rules.length
msgid "min. {0} characters"
msgstr "min. {0} Zeichen"

msgid "More"
msgstr "Mehr"

msgid "More options"
msgstr "Weitere Optionen"

msgid "Move to recycle bin"
msgstr "In den Papierkorb verschieben"

msgid "My Logins"
msgstr "Meine Logins"

msgid "Name may not be empty!"
msgstr "Name darf nicht leer sein!"

msgid "Network name (SSID)"
msgstr "Netzwerkname (SSID)"

msgid "New password"
msgstr "Neues Passwort"

msgid "No app found"
msgstr "Keine App gefunden"

msgid "No certificate found in the file"
msgstr "In der Datei wurde kein Zertifikat gefunden"

msgid "No notification received?"
msgstr "Benachrichtigung kommt nicht an?"

msgid "No username set"
msgstr "Kein Nutzername gesetzt"

msgid "Not active, can be set up"
msgstr "Nicht aktiv, kann eingerichtet werden"

msgid "Not active. <0>Instructions</0>"
msgstr "Nicht aktiv. <0>Anleitung</0>"

msgid "Not compliant"
msgstr "Nicht konform"

msgid "Note"
msgstr "Notiz"

msgid "Old password"
msgstr "Altes Passwort"

msgid "Open website"
msgstr "Webseite aufrufen"

msgid "Organization"
msgstr "Organisation"

msgid "Page modified unexpectedly"
msgstr "Seite unerwartet verändert"

msgid "Passkey"
msgstr "Passkey"

msgid "Password"
msgstr "Passwort"

msgid "Password checked"
msgstr "Geprüftes Passwort"

msgid "Password is empty"
msgstr "Passwort ist leer"

msgid "Password manager without a Master Password"
msgstr "Der Passwort-Manager ohne Master-Passwort"

msgid "Password origin:"
msgstr "Passwort-Herkunft:"

msgid "Password policy"
msgstr "Passwort-Policy"

msgid "Password policy:"
msgstr "Passwort-Policy:"

msgid "Password policy: <0><1/> Violated</0>"
msgstr "Passwort-Policy: <0><1/> Verletzt</0>"

msgid "Password quality:"
msgstr "Passwort-Qualität:"

msgid "Personal Logins"
msgstr "Persönliche Logins"

msgid "PgDn"
msgstr "Bild↓"

msgid "PgUp"
msgstr "Bild↑"

msgid "PIN"
msgstr "PIN"

msgid "PIN, leak check not applicable"
msgstr "PIN, Leak-Check nicht durchführbar"

msgid "Please add an ELSTER certificate file (.pfx)"
msgstr "Bitte füge eine ELSTER-Zertifikatsdatei hinzu (.pfx)"

msgid "Please enter a label"
msgstr "Bitte gib ein Label ein"

msgid "Please reload to use the latest version."
msgstr "Bitte lade die Seite neu, um die aktuelle Version zu verwenden."

msgid "Private account"
msgstr "Privater Account"

msgid "Recheck"
msgstr "Erneut prüfen"

msgid "Regenerate"
msgstr "Neu generieren"

msgid "Reload"
msgstr "Neu laden"

msgid "Remove label"
msgstr "Label entfernen"

msgid "Remove shared login"
msgstr "Geteiltes Login entfernen"

msgid "Replace"
msgstr "Ersetzen"

msgid "Reset"
msgstr "Zurücksetzen"

msgid "Reset settings"
msgstr "Einstellungen zurücksetzen"

msgid "Restore"
msgstr "Wiederherstellen"

msgid "Restoring…"
msgstr "Wird wiederhergestellt…"

msgid "Save"
msgstr "Speichern"

msgid "Save {changeCount, plural, one {# change} other {# changes}}"
msgstr "{changeCount, plural, one {Eine Änderung} other {# Änderungen}} speichern"

msgid "Save new entry"
msgstr "Neuen Eintrag speichern"

msgid "Saved"
msgstr "Gespeichert"

msgid "Saved successfully"
msgstr "Erfolgreich gespeichert"

msgid "Saving"
msgstr "Wird gespeichert"

msgid "Secure note"
msgstr "Sichere Notiz"

msgid "Secure note information"
msgstr "Notiz-Informationen"

msgid "Secure password"
msgstr "Sicheres Passwort"

msgid "Security code"
msgstr "Sicherheitscode"

#. placeholder {0}: card.code.name
#. placeholder {1}: card.code.size
msgid "Security code ({0}, {1, plural, one {# digit} other {# digits}})"
msgstr "Sicherheitscode ({0}, {1, plural, one {# Ziffer} other {# Ziffern}})"

msgid "Security key access not allowed"
msgstr "Zugriff auf Sicherheitsschlüssel nicht erlaubt"

msgid "Selector"
msgstr "Selektor"

msgid "Sender"
msgstr "Absender"

msgid "Sent by"
msgstr "Login-Absender"

msgid "Serial number"
msgstr "Seriennummer"

msgid "Settings"
msgstr "Einstellungen"

msgid "Share"
msgstr "Teilen"

msgid "Shared link"
msgstr "Geteilter Link"

#. placeholder {0}: passwordOrigin.senderEmail
msgid "Shared link from {0}"
msgstr "Geteilter Link von {0}"

msgid "Shift"
msgstr "Umschalt"

msgid "Show"
msgstr "Anzeigen"

#. placeholder {0}: field.name
msgid "Show {0}"
msgstr "{0} anzeigen"

msgid "Show credit card once"
msgstr "Kreditkarte einmalig anzeigen"

msgid "Show ELSTER certificate once"
msgstr "ELSTER-Zertifikat einmal anzeigen"

msgid "Show login once"
msgstr "Login einmalig anzeigen"

msgid "Show password"
msgstr "Passwort anzeigen"

msgid "Show PIN"
msgstr "PIN anzeigen"

msgid "Show secure note once"
msgstr "Sichere Notiz einmalig anzeigen"

msgid "Show security code"
msgstr "Sicherheitscode anzeigen"

msgid "Show TOTP secret"
msgstr "TOTP-Schlüssel anzeigen"

msgid "Show Wi-Fi once"
msgstr "WLAN einmalig anzeigen"

msgid "Show Wi-Fi QR code"
msgstr "Zeige WLAN-QR-Code"

msgid "Site notice"
msgstr "Impressum"

msgid "Space"
msgstr "Leertaste"

msgid "Start for free"
msgstr "Kostenlos starten"

msgid "System clock is correct now."
msgstr "Uhrzeit ist jetzt korrekt."

msgid "The following credit card was shared with you:"
msgstr "Folgende Kreditkarte wurde mit dir geteilt:"

msgid "The following ELSTER certificate was shared with you:"
msgstr "Folgendes ELSTER-Zertifikat wurde mit dir geteilt:"

msgid "The following login was shared with you:"
msgstr "Folgendes Login wurde mit dir geteilt:"

msgid "The following secure note was shared with you:"
msgstr "Folgende sichere Notiz wurde mit dir geteilt:"

msgid "The following Wi-Fi was shared with you:"
msgstr "Folgendes WLAN wurde mit dir geteilt:"

msgid "the owner"
msgstr "der Besitzer"

msgid "The usage of heylogin is governed exclusively by our <0>Terms of Use</0>."
msgstr "Für die Nutzung von heylogin gelten ausschließlich unsere <0>Nutzungsbedingungen</0>."

msgid "There are unsaved changes. <0>Save now</0>"
msgstr "Ungespeicherte Änderungen. <0>Jetzt speichern</0>"

msgid "This credit card is shared from a team by {linkedByEmail}."
msgstr "Diese Kreditkarte wird von {linkedByEmail} aus einem Team mit dir geteilt."

msgid "This credit card is shared from a team."
msgstr "Diese Kreditkarte wird aus einem Team mit dir geteilt."

msgid "This credit card is shared from team {link}."
msgstr "Diese Kreditkarte wird aus dem Team {link} mit dir geteilt."

msgid "This credit card is shared with you by {originEmail}."
msgstr "Diese Kreditkarte wird von {originEmail} mit dir geteilt."

msgid "This credit card is shared with you by another user."
msgstr "Diese Kreditkarte wird von einem anderen Nutzer mit dir geteilt."

msgid "This ELSTER certificate is shared from a team by {linkedByEmail}."
msgstr "Dieses ELSTER-Zertifikat wird von {linkedByEmail} aus einem Team mit dir geteilt."

msgid "This ELSTER certificate is shared from a team."
msgstr "Dieses ELSTER-Zertifikat wird aus einem Team mit dir geteilt."

msgid "This ELSTER certificate is shared from team {link}."
msgstr "Dieses ELSTER-Zertifikat wird aus dem Team {link} mit dir geteilt."

msgid "This ELSTER certificate is shared with you by {originEmail}."
msgstr "Dieses ELSTER-Zertifikat wird von {originEmail} mit dir geteilt."

msgid "This ELSTER certificate is shared with you by another user."
msgstr "Dieses ELSTER-Zertifikat wird von einem anderen Nutzer mit dir geteilt."

msgid "This file is not a valid ELSTER certificate"
msgstr "Die Datei ist kein valides ELSTER-Zertifikat"

msgid "This link is no longer valid!"
msgstr "Dieser Link ist nicht mehr gültig"

msgid "This link seems to be invalid. Please contact the sender of this link."
msgstr "Dieser Link scheint nicht mehr gültig zu sein. Wende dich an den Absender des Links."

msgid "This login is shared from a team by {linkedByEmail}."
msgstr "Dieses Login wird von {linkedByEmail} aus einem Team mit dir geteilt."

msgid "This login is shared from a team."
msgstr "Dieses Login wird aus einem Team mit dir geteilt."

msgid "This login is shared from team {link}."
msgstr "Dieses Login wird aus dem Team {link} mit dir geteilt."

msgid "This login is shared with you by {originEmail}."
msgstr "Dieses Login wird von {originEmail} mit dir geteilt."

msgid "This login is shared with you by another user."
msgstr "Dieses Login wird von einem anderen Nutzer mit dir geteilt."

#. placeholder {0}: format(new Date(login.editTime), 'PPP', { locale: getDateFnsLocale(), })
msgid "This login was submitted to your login inbox on {0}."
msgstr "Dieses Login wurde am {0} in deinen Login-Posteingang übermittelt."

#. placeholder {0}: relatedDomains.length
msgid "This login will also be shown on {0} additional websites."
msgstr "Dieses Login wird auch auf {0} weiteren Webseiten angezeigt."

#. placeholder {0}: relatedDomains.slice(0, relatedDomains.length - 1).join(', ')
#. placeholder {1}: relatedDomains[relatedDomains.length - 1]
msgid "This login will also be shown on {0} and {1}."
msgstr "Dieses Login wird auch auf {0} und {1} angezeigt."

#. placeholder {0}: relatedDomains[0]
msgid "This login will also be shown on {0}."
msgstr "Dieses Login wird auch auf {0} angezeigt."

msgid "This note is shared from a team by {linkedByEmail}."
msgstr "Diese Notiz wird von {linkedByEmail} aus einem Team mit dir geteilt."

msgid "This note is shared from a team."
msgstr "Diese Notiz wird aus einem Team mit dir geteilt."

msgid "This note is shared from team {link}."
msgstr "Diese Notiz wird aus dem Team {link} mit dir geteilt."

msgid "This note is shared with you by {originEmail}."
msgstr "Diese Notiz wird von {originEmail} mit dir geteilt."

msgid "This note is shared with you by another user."
msgstr "Diese Notiz wird von einem anderen Nutzer mit dir geteilt."

msgid "This password was found in a list of leaked passwords. Please do not use it!"
msgstr "Dieses Passwort wurde auf einer Liste von geleakten Passwörtern gefunden. Bitte nicht verwenden!"

msgid "This TOTP code uses parameters that differ from the default."
msgstr "Dieser TOTP-Code benutzt von der Voreinstellung abweichende Parameter."

msgid "This Wi-Fi network is shared from a team by {linkedByEmail}."
msgstr "Dieses WLAN-Netzwerk wird von {linkedByEmail} aus einem Team mit dir geteilt."

msgid "This Wi-Fi network is shared from a team."
msgstr "Dieses WLAN-Netzwerk wird aus einem Team mit dir geteilt."

msgid "This Wi-Fi network is shared from team {link}."
msgstr "Dieses WLAN-Netzwerk wird aus dem Team {link} mit dir geteilt."

msgid "This Wi-Fi network is shared with you by {originEmail}."
msgstr "Dieses WLAN-Netzwerk wird von {originEmail} mit dir geteilt."

msgid "This Wi-Fi network is shared with you by another user."
msgstr "Dieses WLAN-Netzwerk wird von einem anderen Nutzer mit dir geteilt."

msgid "Tip: A display name helps differentiate logins."
msgstr "Tipp: Ein Anzeigename hilft, Logins zu unterscheiden."

msgid "Title"
msgstr "Titel"

msgid "Too many files"
msgstr "Zu viele Dateien"

msgid "TOTP"
msgstr "TOTP"

msgid "TOTP (2FA) availability sourced from <0>2FA Directory</0>."
msgstr "Daten zur Verfügbarkeit von TOTP (2FA) bereitgestellt von <0>2FA Directory</0>."

msgid "TOTP (2FA):"
msgstr "TOTP (2FA):"

msgid "TOTP algorithm"
msgstr "TOTP-Algorithmus"

msgid "TOTP code might be invalid due to incorrect system clock on this device. Please set your system time to the current time."
msgstr "TOTP-Code könnte ungültig sein aufgrund abweichender Uhrzeit auf diesem Gerät. Bitte stelle die Systemzeit auf die aktuelle Zeit."

msgid "TOTP code:"
msgstr "TOTP-Code:"

msgid "TOTP length"
msgstr "TOTP-Länge"

msgid "TOTP period"
msgstr "TOTP-Periode"

msgid "TOTP secret"
msgstr "TOTP-Schlüssel"

msgid "Try again"
msgstr "Erneut versuchen"

msgid "Unknown credit card"
msgstr "Unbekannte Kreditkarte"

msgid "Unknown error"
msgstr "Unbekannter Fehler"

#. placeholder {0}: error?.name
msgid "Unknown error: {0}"
msgstr "Unbekannter Fehler: {0}"

msgid "Unknown field"
msgstr "Unbekanntes Feld"

msgid "Unknown Wi-Fi network"
msgstr "Unbekanntes WLAN-Netzwerk"

msgid "Unnamed login"
msgstr "Unbenanntes Login"

msgid "Unnamed team"
msgstr "Unbenanntes Team"

msgid "Use as default settings"
msgstr "Als Standardeinstellungen nutzen"

msgid "User display name"
msgstr "Nutzer-Anzeigename"

msgid "Username"
msgstr "Nutzername"

msgid "Username or e-mail address"
msgstr "Benutzername oder E-Mail-Adresse"

msgid "Valid from"
msgstr "Gültig ab"

msgid "Valid until"
msgstr "Gültig bis"

msgid "Waiting to check"
msgstr "Warte auf Überprüfung"

msgid "Website"
msgstr "Website"

msgid "Website or app"
msgstr "Website oder App"

msgid "Websites"
msgstr "Websites"

msgid "Wi-Fi information"
msgstr "WLAN-Informationen"

msgid "Wi-Fi network"
msgstr "WLAN-Netzwerk"

msgid "Windows app"
msgstr "Windows-App"

msgid "Windows apps"
msgstr "Windows-Apps"

msgctxt "it = credit card"
msgid "You can only read it."
msgstr "Du kannst sie nur lesen."

msgctxt "it = ELSTER certificate"
msgid "You can only read it."
msgstr "Du kannst es nur lesen."

msgctxt "it = login"
msgid "You can only read it."
msgstr "Du kannst es nur lesen."

msgctxt "it = note"
msgid "You can only read it."
msgstr "Du kannst sie nur lesen."

msgctxt "it = Wi-Fi"
msgid "You can only read it."
msgstr "Du kannst es nur lesen."

msgid "You can only read this credit card."
msgstr "Du kannst diese Kreditkarte nur lesen."

msgid "You can only read this ELSTER certificate."
msgstr "Du kannst dieses ELSTER-Zertifikat nur lesen."

msgid "You can only read this login."
msgstr "Du kannst dieses Login nur lesen."

msgid "You can only read this note."
msgstr "Du kannst diese Notiz nur lesen."

msgid "You can only read this Wi-Fi network."
msgstr "Du kannst dieses WLAN-Netzwerk nur lesen."

msgctxt "it = ELSTER certificate"
msgid "You can only use it to log in with the heylogin browser extension."
msgstr "Du kannst dich damit nur mit der heylogin-Browser-Erweiterung einloggen."

msgctxt "it = login"
msgid "You can only use it to log in with the heylogin browser extension."
msgstr "Du kannst dich damit nur mit der heylogin-Browser-Erweiterung einloggen."

msgid "You can only use this ELSTER certificate to log in with the heylogin browser extension."
msgstr "Du kannst dich mit diesem ELSTER-Zertifikat nur mit der heylogin-Browser-Erweiterung einloggen."

msgid "You can only use this login to log in with the heylogin browser extension."
msgstr "Du kannst dich mit diesem Login nur mit der heylogin-Browser-Erweiterung einloggen."

msgid "You have {remainingMinutes, plural, one {less than one minute} other {# minutes}} to edit this credit card. After that, only {ownerEmail} can edit it."
msgstr "Du hast {remainingMinutes, plural, one {weniger als eine Minute} other {# Minuten}} Zeit, um die Kreditkarte anzupassen. Danach kann nur noch {ownerEmail} sie bearbeiten."

msgid "You have {remainingMinutes, plural, one {less than one minute} other {# minutes}} to edit this login. After that, only {ownerEmail} can edit it."
msgstr "Du hast {remainingMinutes, plural, one {weniger als eine Minute} other {# Minuten}} Zeit, um das Login anzupassen. Danach kann nur noch {ownerEmail} es bearbeiten."

msgid "Your browser was unable to access the security key. You may need to grant permissions in your operating system."
msgstr "Dein Browser konnte nicht auf den Sicherheitsschlüssel zugreifen. Erlaube den Zugriff in den Systemeinstellungen."
